import { CallInfo, Constants, Contact, PhoneCall, PhoneCallAttributes } from '@salesforce/scv-connector-base';

export class AmcCall extends PhoneCall {
  tag: string;
  parties: string[];
  alreadyRaisedToSalesforce: boolean;
  vendorCallKey: string;
  degCallId?: string;
  startTime: Date;

  constructor({ callId, callType, contact, state, callAttributes, phoneNumber, callInfo, reason, closeCallOnError, agentStatus, agentARN, tag, parties, alreadyRaisedToSalesforce, vendorCallKey, startTime }: {
          tag: string;
          parties: string[];
          alreadyRaisedToSalesforce: boolean;
          callId?: string; // ! callId is the returned value from DEG or the interactionId for clientSideCall creation.
          callType?: Constants.CALL_TYPE;
          contact?: Contact;
          state?: Constants.CALL_STATE;
          callAttributes?: PhoneCallAttributes;
          phoneNumber?: string;
          callInfo?: CallInfo;
          reason?: Constants.HANGUP_REASON;
          closeCallOnError?: boolean;
          agentStatus?: Constants.AGENT_STATUS | Constants.HANGUP_STATUS;
          agentARN?: string;
          vendorCallKey: string; // ! original vendorCallKeyCad if it exists. Used for updated call.
          startTime?: Date; // ! date is the start time of the call.
  }) {
    super({ callId, callType, contact, state, callAttributes, phoneNumber, callInfo, reason, closeCallOnError, agentStatus, agentARN });

    this.tag = tag;
    this.parties = parties;
    this.alreadyRaisedToSalesforce = alreadyRaisedToSalesforce;
    this.startTime = startTime ?? new Date();
    this.vendorCallKey = vendorCallKey;
  }
}
